import { SessionManager } from '@cobliteam/api-lib';

import type { Session } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { type UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getSessionManager = () => new SessionManager({ host: env.herbieApiHost });

export const QUERY_KEY = 'LOGIN';
export const QUERY_KEY_SSO_TOKEN = 'SSO_TOKEN';

const useLogin = () => {
  return useMutation<Session, unknown, { username: string; password: string }>({
    mutationFn: ({ username, password }) => getSessionManager().login(username, password),
  });
};

const useGetHubSpotSSOToken = (options?: Partial<UseQueryOptions<string>>) => {
  return useQuery<string>({
    queryKey: [QUERY_KEY, QUERY_KEY_SSO_TOKEN],
    queryFn: () => getSessionManager().getHubSpotSSOToken(),
    ...options,
  });
};

export { useGetHubSpotSSOToken, useLogin };
export default QUERY_KEY;
